export const GET_DEPOSITS = "GET_DEPOSITS";
export const GOT_DEPOSITS = "GOT_DEPOSITS";
export const GOT_DEPOSITS_ERROR = "GOT_DEPOSITS_ERROR";

export const GET_DEPOSIT = "GET_DEPOSIT";
export const GOT_DEPOSIT = "GOT_DEPOSIT";
export const GOT_DEPOSIT_ERROR = "GOT_DEPOSIT_ERROR";
